// extracted by mini-css-extract-plugin
module.exports = {"request":"ErrorRequestId_request__pSEhX typography_caption-s__Pl_G9"};